import { Context } from "./Reducers/Store";
import React, { useCallback, useState, useEffect, useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";
import AlertComponent from "./Components/AlertComponent";

function RequireAuth({ children, roles = [] }) {
    const [state, dispatch] = useContext(Context);
    let location = useLocation();

    if (!state.isLogged) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    else {
        if (roles != null && roles.length > 0) {
            if (!roles.includes(state.profile?.role)) {
                AlertComponent("Error", "Your user is not authorized to access this resource.", { icon: `error` });
                return <Navigate to="/" replace />;
            }
        }
        if (location.pathname != "/codeVerification" && !state.profile?.emailValidated)
            return <Navigate to="/codeVerification" state={{ from: location }} replace />;
        else if (state.profile?.emailValidated && location.pathname != "/branding" && !state.hasBranding)
            return <Navigate to="/branding" state={{ from: location }} replace />;
        else if (state.profile?.emailValidated && state.hasBranding && location.pathname != "/selectPlan" && (!state.hasPlan || !state.church?.active))
            return <Navigate to="/selectPlan" state={{ from: location }} replace />;
    }

    return children;
}

export default RequireAuth;